import React from "react"
import i18n from "../services/i18n"

// tog'a #271 (2026-10-20): tizim test rejimida — HAR QANDAY xato xabari ostida foydalanuvchiga
// «kamchilik ko'rsangiz xabar bering» yozuvi chiqadi (tuzatishga ulgurilmagan xato bo'lsa ham tushunarli bo'lsin).
// Ulanishi: utils/config.ts dagi message.error / notification.error o'ramida (takror-filtridan KEYIN).
export const testModeText = () => i18n.t("testModeNotice")

export const TestModeNote = () => <div className="test-mode-note">⚠️ {testModeText()}</div>

export const withTestModeNote = (content: React.ReactNode) => (
  <span className="test-mode-wrap">
    {content}
    <TestModeNote />
  </span>
)
